import { render, staticRenderFns } from "./EscolherPerfil.vue?vue&type=template&id=884b9098&scoped=true&"
import script from "./EscolherPerfil.vue?vue&type=script&lang=js&"
export * from "./EscolherPerfil.vue?vue&type=script&lang=js&"
import style0 from "./EscolherPerfil.vue?vue&type=style&index=0&id=884b9098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884b9098",
  null
  
)

export default component.exports